import { customElement } from 'lit/decorators';
import { css, html, LitElement } from 'lit';
import { center, padding, row } from '../styles';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';

import CodeIcon from '@carbon/web-components/es/icons/code/16';
import { annotation } from './common';
import '@carbon/web-components/es/components/structured-list/';

import '../index';
import '../flow/pdq-data-request';
import '../flow/pdq-transform';
import '../flow/pdq-table';
import '../flow/pdq-perspective-viewer';


@customElement('pdq-tutorial-transform-data')
class PDQTutorialTransformData extends LitElement {
  static styles = [
    row,
    center,
    padding,
    annotation,
    ];

  render() {
    const code = `<pdq-data-request id="posts" url="https://jsonplaceholder.typicode.com/posts"></pdq-data-request>
<pdq-transform id="transformed" sources='["posts"]'>
<script type="module" slot="transform">
export async function transform(sources){
  const [data] = sources
  console.log('transforming data', data) 
  const ret = data.map(i => {
    i.title = i.title.toUpperCase()
    i.id *= 2;
    return i
  })
  console.log('transformed data', ret)
  return ret
}
</script>
</pdq-transform>
<pdq-table id="transformed-table" source="transformed"></pdq-table>
<pdq-perspective-viewer table="transformed-table" height="200px"></pdq-perspective-viewer>
`
    return html`
      <cds-tile class="col">

        <h2>Transforming Data</h2>

        <p>You can use the <cds-tag type="green">${CodeIcon({ slot: 'icon' })}pdq-tranform</cds-tag>
        to create a new data source in the data model that is base on one or more 
        data sources. The transform is run when ever the sources change so it will
        always stay upto date</p>
        
        <pdq-code-html code="${code}"></pdq-code-html>
        ${unsafeHTML(code)}
        
        <p>The code in the transform is arbitrary, you must provide an exported transform function that will be called
        when ever the any of the data sources changes, the result is added to the data model under the id</p>
        
        <p>The output is part of a cold observable chain, so transform will only be </p>
        
        
      </cds-tile>
    `;
  }
}